var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"menu"},_vm._l((_vm.menuList),function(item){return _c('div',{key:item.id,class:_vm.activeMenu== item.id?'activeMenu':'',on:{"click":function($event){return _vm.menuBar(item.id)}}},[_c('span',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('i',{staticClass:"activeIcon"})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-c11b39da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/container/menu.vue
// module id = fXDE
// module chunks = 1